import { Cookie, Settings2 } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const COOKIE_PREFERENCES_KEY = "gameday-cookie-preferences";

function readPreferences() {
  try {
    return JSON.parse(window.localStorage.getItem(COOKIE_PREFERENCES_KEY) || "null");
  } catch {
    return null;
  }
}

function savePreferences(preferences) {
  window.localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(preferences));
}

export { COOKIE_PREFERENCES_KEY, readPreferences, savePreferences };

export default function CookieConsentBanner() {
  const navigate = useNavigate();
  const [preferences, setPreferences] = useState(readPreferences);

  if (preferences) return null;
  const save = (optionalCookies) => {
    const nextPreferences = { essential: true, analytics: optionalCookies, marketing: optionalCookies, updated_at: new Date().toISOString() };
    savePreferences(nextPreferences);
    setPreferences(nextPreferences);
  };

  return <aside className="cookie-consent-banner" data-testid="cookie-consent-banner"><Cookie size={24} /><div><strong>Privacy choices</strong><p>Essential cookies keep this site secure. You can choose whether analytics and marketing cookies are used.</p></div><div className="cookie-consent-actions"><button className="button button--outline" onClick={() => navigate("/privacy-preferences")} data-testid="cookie-consent-manage-button"><Settings2 size={15} />Manage</button><button className="button button--ghost" onClick={() => save(false)} data-testid="cookie-consent-essential-button">Essential only</button><button className="button button--red" onClick={() => save(true)} data-testid="cookie-consent-accept-button">Accept optional</button></div></aside>;
}